export interface IProviderResponse<Type> {
  data: Type | null | undefined,
  error: string | null | undefined,
}

export const ResponseData = <Type extends Record<string, any>>(data: Type) => ({
  data,
  error: null,
});

export const ResponseError = (message: string) => ({
  data: null,
  error: message,
});
